<template>
  <v-card class="fill-height card-height" rounded="lg" outlined>
    <v-card-item>
      <v-select
        v-model="selectedStandardDisplay"
        :items="selectedStandards"
        item-title="text"
        item-value="value"
        :label="$t('labels.select-standard-display')"
        variant="outlined"
        density="compact"
        hide-details="auto"
        style="width: 300px"
        class="ma-4"
        :disabled="selectedStandards?.length == 0"
      />
    </v-card-item>

    <v-card-text v-if="exportModel" class="pa-0 fill-height json-card-custom">
      <div class="json-scroll-container">
        <pre class="pa-4" style="white-space: pre-wrap">{{
          JSON.stringify(exportModel, null, 2)
        }}</pre>
      </div>
    </v-card-text>

    <v-card-text
      v-else
      class="fill-height d-flex flex-column align-center justify-center text-center json-card-custom"
    >
      <v-icon size="48" color="grey">mdi-file-question</v-icon>
      <div class="text-h6 mt-2">{{ $t("labels.no-standard-selected") }}</div>
      <div class="text-body-2 text-grey mt-1">
        {{ $t("labels.select-standard-to-generate") }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, watch, defineEmits } from "vue";

const props = defineProps(["exportModels", "selectedStandards"]);
const emits = defineEmits(["changedDisplayStandard"]);

const selectedStandardDisplay = ref(null);
const exportModel = ref(null);

watch(
  () => props.selectedStandards,
  () => {
    selectedStandardDisplay.value = null;
    exportModel.value = null;
  },
  { immediate: true },
);

watch(
  selectedStandardDisplay,
  (newVal) => {
    if (newVal && props?.exportModels?.[newVal]) {
      exportModel.value = { ...props.exportModels[newVal] };
      delete exportModel.value.obsolete;
      emits("changedDisplayStandard", newVal);
    }
  },
  { immediate: true },
);
</script>

<style scoped>
.card-height {
  height: calc(100vh - 358px) !important;
}

.json-card-custom {
  height: calc(100vh - 440px) !important;
  background-color: #1e1e1e;
  color: #ffffff;
  font-family: "Fira Code", monospace;
}

.json-scroll-container {
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
}

.json-scroll-container::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

.json-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.json-scroll-container:hover::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.4);
}
</style>
